"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

var intellegenceService = {
  getPositions: function (id, options, reportId) {
    return api.post(
      "/reports/" + reportId + "/view",
      [id],
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getParkings: function (id, options) {
    return api.get(
      "/units/" + id + "/parkings",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getFuelings: function (id, options) {
    return api.get(
      "/units/" + id + "/fuelings",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getDrains: function (id, options) {
    return api.get(
      "/units/" + id + "/drains",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getSpeedingPoints: function (id, options) {
    return api.get(
      `/Units/${id}/SpeedingPoints`,
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getGpsJammings: function (id, options) {
    return api.get(
      `/Units/${id}/GpsJammings`,
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getDataPositions: function (id, options) {
    return api.get(
      "/units/" + id + "/DataPositions",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getChartSensors: function (id, options, reportId) {
    const units = id === null ? [] : [id];

    return api.post(
      `/reports/${reportId}/view`,
      units,
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getMapPositions: function (id, options) {
    return api.get(
      "/units/" + id + "/MapPositions",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getOrigenalPositions: function (id, options) {
    return api.get(
      "/units/" + id + "/OrigenalPositions",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getPositionTimeDatas: function (id, options) {
    return api.get(
      "/units/" + id + "/PositionTimeDatas",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getSensorsData: function (id, options) {
    return api.get(
      "/units/" + id + "/Sensors",
      WithToken.headersToken(
        {
          params: options,
        },
        "authTNToken"
      )
    );
  },
  getDashboards: function () {
    return api.get("/Dashboards", WithToken.headersToken({}, configuration.cookieName));
  },
  getDashboardCodes: function () {
    return api.get("/Dashboards/Codes", WithToken.headersToken({}, configuration.cookieName));
  },
  getDashboard: function (carId) {
    return api.get("/Units/" + carId + "/Dashboard", WithToken.headersToken({}, configuration.cookieName));
  },
};

export default intellegenceService;
